<template>
  <div>
    <div class="modal fade" id="addQuoteRequestModal" ref="modalEle" tabindex="-1" role="dialog"
      aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Utwórz zapytanie ofertowe</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="form && isReady" class="container-fluid">
              <div class="row">

                <div class="col-md-5">
                  <label for="dueDate">Ostateczny termin otrzymania<br> odpowiedzi na zapytanie
                    ofertowe:</label>
                  <div class="mb-4" style="max-width: 300px;">
                    <ejs-datepicker id="projectFileProgressId" v-model="form.dueDate" placeholder="Wybierz datę"
                      :format="'dd.MM.yyyy'" @change="onDueDateChange"></ejs-datepicker>
                  </div>
                </div>

                <div class="col-md-7">
                  <label for="emails">Wyślij zapytanie ofertowe na poniższe maile:</label>

                  <div v-if="hasError(`emails`)" class="text-danger small">
                    {{ getErrorMessage(`emails`) }}
                  </div>

                  <table class="table">
                    <tbody>
                      <tr v-for="(email, key) in form.emails">
                        <td style="vertical-align: top">
                          <TagSelect :endpoint="route('customers.get-customers-with-contacts')" label="Mail Dostawcy"
                            label-key="label" value-key="value" name="emailsTo[]" v-model="form.emails[key].to"
                            @selected="setEmailCustomer(key, $event)" :max="1" />
                        </td>
                        <td style="vertical-align: top">
                          <TagSelect :endpoint="route('customers.get-customers-with-contacts')" label="Maile DW"
                            label-key="label" value-key="value" name="emailsDw[]" v-model="form.emails[key].dw" />
                        </td>
                        <td style="vertical-align: top">
                          <button type="button" class="ms-2 btn btn-sm btn-outline-danger"
                            @click="removeEmailsRow(key)">
                            <i class="bi bi-dash-circle"></i>
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2"></td>
                        <td>
                          <button type="button" class="ms-2 btn btn-sm btn-outline-success" @click="addEmailsRow">
                            <i class="bi bi-plus-circle"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <Vueform :key="vueformKey">
                    <TextElement name="comment" @change="changeComment($event)" autocomplete="off"
                      label="Komentarz do zapytania" placeholder="Komentarz będzie widoczny dla dostawcy" />
                  </Vueform>
                </div>
              </div>
              <template v-for="group in groupedArticles" :key="group.key">
                <template v-if="group.indexes.length === 1">
                  <template v-for="idx in group.indexes" :key="idx">
                    <table class="table">
                      <tbody>
                        <tr>
                          <td colspan="2" class="position-relative">
                            <span>#{{ idx + 1 }}</span>
                            <button type="button"
                              class="btn btn-sm btn-outline-danger position-absolute end-0 top-50 translate-middle-y me-1"
                              title="Usuń artykuł" @click="removeArticle(idx)">
                              <i class="bi bi-trash"></i>
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td class="widthFirstTd">Nr katalogowy</td>
                          <td>{{ form.articles[idx].catalog_number }}</td>
                        </tr>
                        <tr>
                          <td class="widthFirstTd">Model</td>
                          <td>{{ form.articles[idx].model }}</td>
                        </tr>
                        <tr>
                          <td class="widthFirstTd">
                            Ilość zamawiana
                            <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top"
                              data-bs-html="true"
                              title="Całkowita ilość. Powinna być pomniejszona o zarezerwowane sztuki."></i>
                          </td>
                          <td>
                            <div v-if="hasError(`articles.${idx}.quantity_required`)" class="text-danger small">{{
                              getErrorMessage(`articles.${idx}.quantity_required`) }}
                            </div>
                            <div class="d-flex align-items-center gap-2">
                              <input class="form-control form-control-sm" style="width: 120px;" type="number"
                                step="0.01" min="0" v-model.number="form.articles[idx].quantity_required" required>

                              <select v-model="form.articles[idx].unit_id" class="form-select form-select-sm"
                                style="width: 180px;" @change="updateArticleUnit(idx)">
                                <option :value="null">
                                  -- wybierz jednostkę --
                                </option>

                                <option v-for="unit in units" :key="unit.id" :value="Number(unit.id)">
                                  {{ unit.name }}
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                        <tr
                          v-if="reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`]">
                          <td class="widthFirstTd">
                            Zarezerwowane
                            <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top"
                              data-bs-html="true"
                              title="Zarezerwowana ilość pomniejszona o sztuki, które już trafiły na magazyn projektowy"></i>
                          </td>
                          <td>
                            <span
                              v-if="reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`].currentlyReserved > 0"
                              :class="reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`].reservationStatus === 'zatwierdzone' ? 'reservation-approved' : 'reservation-notapproved'">
                              {{
                                reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`].currentlyReserved
                              }} -
                              {{
                                reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`].reservationStatus
                              }}.
                            </span>
                            <span v-else>Brak rezerwacji.</span>
                            <span
                              v-if="reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`].fulfilledQuantity">
                              Wydanych z rezerwacji: {{
                                reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`].fulfilledQuantity
                              }}.
                            </span>
                            <span v-if="form.articles[idx].in_target_warehouse"> Na
                              magazynie docelowym: {{
                                form.articles[idx].in_target_warehouse }}</span>
                          </td>
                        </tr>
                        <tr v-else>
                          <td class="widthFirstTd">Zarezerwowane</td>
                          <td><span>Ładowanie...</span></td>
                        </tr>
                        <tr>
                          <td class="widthFirstTd">Producent</td>
                          <td>
                            <p><small><i class="text-muted">Producent wymagany przez
                                  klienta:
                                  <b v-if="producentSelectedInProject[form.articles[idx].article_id]">{{
                                    producentSelectedInProject[form.articles[idx].article_id].join(',')
                                  }}</b>
                                  <b v-else>Brak</b>
                                </i></small></p>
                            <template v-if="form.articles[idx].producer_name">
                              <span class="font-weight-bolder"
                                :class="getProducerClass(form.articles[idx].article_id, form.articles[idx].producer_name)">
                                {{ form.articles[idx].producer_name }}
                              </span>
                            </template>
                            <template v-else><i>Brak domyślnego producenta</i></template>
                          </td>
                        </tr>
                        <tr>
                          <td class="widthFirstTd">Uwagi do pozycji</td>
                          <td><input type="text" class="form-control form-control-sm"
                              v-model="form.articles[idx].comments"></td>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                </template>
                <template v-else>
                  <table class="table">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <div class="d-flex align-items-center justify-content-between gap-3">
                            <div class="d-flex align-items-center gap-2 flex-grow-1 min-width-0">
                              <span class="badge bg-info">Połączone pozycje: {{
                                group.indexes.length }}</span>
                              <span class="text-muted small text-truncate">#{{
                                group.indexes.map(i => i + 1).join(' · #')}}</span>
                            </div>
                            <div class="d-flex align-items-center gap-1 flex-shrink-0">
                              <button type="button" class="btn btn-sm btn-outline-info"
                                :title="isArticleGroupExpanded(group.key) ? 'Zwiń pozycje' : 'Rozwiń pozycje'"
                                @click="toggleArticleGroup(group.key)">
                                <i
                                  :class="isArticleGroupExpanded(group.key) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-outline-danger" title="Usuń wszystkie pozycje"
                                @click="removeArticleGroup(group)">
                                <i class="bi bi-trash"></i>
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="widthFirstTd">Nr katalogowy</td>
                        <td>{{ group.firstArticle.catalog_number }}</td>
                      </tr>
                      <tr>
                        <td class="widthFirstTd">Model</td>
                        <td>{{ group.firstArticle.model }}</td>
                      </tr>
                      <tr>
                        <td class="widthFirstTd">
                          Ilość zamawiana
                          <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top"
                            data-bs-html="true" title="Suma ilości wszystkich identycznych pozycji."></i>
                        </td>
                        <td class="d-flex align-items-center gap-2">
                          <input type="number" class="form-control form-control-sm" :value="group.totalQuantity"
                            readonly>

                          <select v-model="form.articles[group.indexes[0]].unit_id" class="form-select form-select-sm"
                            style="width: 180px;" @change="updateGroupUnit(group)">
                            <option :value="null">
                              -- wybierz jednostkę --
                            </option>

                            <option v-for="unit in units" :key="unit.id" :value="Number(unit.id)">
                              {{ unit.name }}
                            </option>
                          </select>
                        </td>
                      </tr>
                      <tr
                        v-if="reservations[`${group.firstArticle.article_id}-${group.firstArticle.required_project_item_id}`]">
                        <td class="widthFirstTd">
                          Zarezerwowane
                          <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="top"
                            data-bs-html="true"
                            title="Zarezerwowana ilość pomniejszona o sztuki, które już trafiły na magazyn projektowy"></i>
                        </td>
                        <td>
                          <span
                            v-if="reservations[`${group.firstArticle.article_id}-${group.firstArticle.required_project_item_id}`].currentlyReserved > 0"
                            :class="reservations[`${group.firstArticle.article_id}-${group.firstArticle.required_project_item_id}`].reservationStatus === 'zatwierdzone' ? 'reservation-approved' : 'reservation-notapproved'">
                            {{
                              reservations[`${group.firstArticle.article_id}-${group.firstArticle.required_project_item_id}`].currentlyReserved
                            }} -
                            {{
                              reservations[`${group.firstArticle.article_id}-${group.firstArticle.required_project_item_id}`].reservationStatus
                            }}
                          </span>
                          <span v-else>Brak rezerwacji.</span>
                          <span
                            v-if="reservations[`${group.firstArticle.article_id}-${group.firstArticle.required_project_item_id}`].fulfilledQuantity">
                            Wydanych z rezerwacji: {{
                              reservations[`${group.firstArticle.article_id}-${group.firstArticle.required_project_item_id}`].fulfilledQuantity
                            }}.
                          </span>
                          <span v-if="group.firstArticle.in_target_warehouse"> Na magazynie
                            docelowym: {{ group.firstArticle.in_target_warehouse }}</span>
                        </td>
                      </tr>
                      <tr v-else>
                        <td class="widthFirstTd">Zarezerwowane</td>
                        <td><span>Ładowanie...</span></td>
                      </tr>
                      <tr>
                        <td class="widthFirstTd">Producent</td>
                        <td>
                          <p><small><i class="text-muted">Producent wymagany przez klienta:
                                <b v-if="producentSelectedInProject[group.firstArticle.article_id]">{{
                                  producentSelectedInProject[group.firstArticle.article_id].join(',')
                                }}</b>
                                <b v-else>Brak</b>
                              </i></small></p>
                          <template v-if="group.firstArticle.producer_name">
                            <span class="font-weight-bolder"
                              :class="getProducerClass(group.firstArticle.article_id, group.firstArticle.producer_name)">
                              {{ group.firstArticle.producer_name }}
                            </span>
                          </template>
                          <template v-else><i>Brak domyślnego producenta</i></template>
                        </td>
                      </tr>
                      <tr>
                        <td class="widthFirstTd">Uwagi do pozycji</td>
                        <td>
                          <div class="d-flex flex-column gap-1">
                            <div v-for="idx in group.indexes" :key="'comment-' + idx" class="d-flex align-items-center">
                              <span class="text-muted me-2">#{{ idx + 1 }}</span>
                              <input type="text" class="form-control form-control-sm"
                                :value="form.articles[idx].comments" readonly>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-if="isArticleGroupExpanded(group.key)" class="border-start border-3 ps-3 mb-3">
                    <template v-for="idx in group.indexes" :key="'expanded-' + idx">
                      <table class="table">
                        <tbody>
                          <tr>
                            <td colspan="2" class="position-relative">
                              <span>#{{ idx + 1 }}</span>
                              <button type="button"
                                class="btn btn-sm btn-outline-danger position-absolute end-0 top-50 translate-middle-y me-1"
                                title="Usuń artykuł" @click="removeArticle(idx)">
                                <i class="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td class="widthFirstTd">Nr katalogowy</td>
                            <td>{{ form.articles[idx].catalog_number }}</td>
                          </tr>
                          <tr>
                            <td class="widthFirstTd">Model</td>
                            <td>{{ form.articles[idx].model }}</td>
                          </tr>
                          <tr>
                            <td class="widthFirstTd">Ilość zamawiana</td>
                            <td>
                              <div v-if="hasError(`articles.${idx}.quantity_required`)" class="text-danger small">{{
                                getErrorMessage(`articles.${idx}.quantity_required`) }}
                              </div>
                              <div class="d-flex align-items-center">
                                <input class="form-control form-control-sm" type="number" step="0.01" min="0"
                                  v-model.number="form.articles[idx].quantity_required" required>
                                <div class="ms-2 text-nowrap">{{
                                  form.articles[idx].unit_name }}</div>
                              </div>
                            </td>
                          </tr>
                          <tr
                            v-if="reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`]">
                            <td class="widthFirstTd">Zarezerwowane</td>
                            <td>
                              <span
                                v-if="reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`].currentlyReserved > 0"
                                :class="reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`].reservationStatus === 'zatwierdzone' ? 'reservation-approved' : 'reservation-notapproved'">
                                {{
                                  reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`].currentlyReserved
                                }} -
                                {{
                                  reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`].reservationStatus
                                }}
                              </span>
                              <span v-else>Brak rezerwacji.</span>
                              <span
                                v-if="reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`].fulfilledQuantity">
                                Wydanych z rezerwacji: {{
                                  reservations[`${form.articles[idx].article_id}-${form.articles[idx].required_project_item_id}`].fulfilledQuantity
                                }}.
                              </span>
                              <span v-if="form.articles[idx].in_target_warehouse"> Na
                                magazynie docelowym: {{
                                  form.articles[idx].in_target_warehouse }}</span>
                            </td>
                          </tr>
                          <tr v-else>
                            <td class="widthFirstTd">Zarezerwowane</td>
                            <td><span>Ładowanie...</span></td>
                          </tr>
                          <tr>
                            <td class="widthFirstTd">Producent</td>
                            <td>
                              <p><small><i class="text-muted">Producent wymagany przez
                                    klienta:
                                    <b v-if="producentSelectedInProject[form.articles[idx].article_id]">{{
                                      producentSelectedInProject[form.articles[idx].article_id].join(',')
                                    }}</b>
                                    <b v-else>Brak</b>
                                  </i></small></p>
                              <template v-if="form.articles[idx].producer_name">
                                <span class="font-weight-bolder"
                                  :class="getProducerClass(form.articles[idx].article_id, form.articles[idx].producer_name)">
                                  {{ form.articles[idx].producer_name }}
                                </span>
                              </template>
                              <template v-else><i>Brak domyślnego
                                  producenta</i></template>
                            </td>
                          </tr>
                          <tr>
                            <td class="widthFirstTd">Uwagi do pozycji</td>
                            <td><input type="text" class="form-control form-control-sm"
                                v-model="form.articles[idx].comments"></td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </div>
                </template>
              </template>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>
            <form @submit.prevent="saveQuoteRequest">
              <button type="submit" class="btn btn-outline-primary me-2" @click="setWithSend(false)"
                :disabled="form.processing || emailsOk">
                <i class="bi bi-save me-2"></i>Zapisz bez wysyłki
              </button>

              <button type="submit" class="btn btn-primary" @click="setWithSend(true)"
                :disabled="form.processing || emailsOk">
                <i class="bi bi-send me-2"></i>Wyślij zapytania ofertowe
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Modal, Tooltip } from "bootstrap";
import { useForm } from "@inertiajs/vue3";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import TagSelect from "./TagSelect.vue";

export default {
  components: { TagSelect, 'ejs-datepicker': DatePickerComponent },
  props: {
    requiredProjectItem: String,
    project: Number | String,
    team: String,
    selectedItems: {
      type: Object,
      default: () => {
      }
    },
    units: {
      type: Array,
      default: () => []
    },
  },

  data() {
    return {
      vueformKey: 0,
      isSaving: false,
      errors: {},
      expandedGroups: {},
      isClosingConfirmed: false,
      isReady: false,
      emailsOk: false,
      quoteRequestNumbers: {},
      modalObj: null,
      allSuppliers: {},
      default_suppliers_id: [],
      reservations: {},
      dueDateFormat: 'dd.MM.yyyy',
      producentSelectedInProject: [],
      form: useForm({
        dueDate: this.defaultDueDate(),
        with_send: true,
        comment: '',
        emails: {
          0: {
            to: null,
            customer_id: null,
            dw: null
          }
        }
      })
    }
  },

  watch: {
    selectedItems: {
      immediate: true,
      async handler(newItems) {
        this.isReady = false;
        if (!newItems) return false;
        this.allSuppliers = this.getSuppliersEmails();
        this.getDefaultProducentForSelectedItem();
        const merged = this.mergeSelectedItems(newItems);
        const currentDueDate = this.form?.dueDate ?? this.defaultDueDate();
        this.form = useForm({
          dueDate: currentDueDate,
          with_send: true,
          comment: '',
          emails: this.prepareSuppliersEmails(newItems),
          project: parseInt(this.project),
          articles: newItems.map(item => ({
            required_project_item_id: item.id,
            project: item.project_id,
            team: item.team_name,
            article_id: item.article.id,
            unit_id: item.article?.unit_id
              ? Number(item.article.unit_id)
              : null,
            unit_name: item.article?.article_unit?.name,
            quote_request_number: null,
            catalog_number: item.article.catalog_number,
            model: item.article.model,
            quantity_required:
              (Number(item.quantity_required) || 0) *
              (item.numbering?.quantity || 1),
            in_target_warehouse: item.article_project_warehouse?.quantity,
            producer_name: item.article?.producer?.name || null,
            producer_id: item.article?.producer_id || '',
            comments: item.comments ?? item.comment ?? null,
          })),
        });

        this.vueformKey++;

        this.isReady = true;
        this.loadReservations();
      },
    },
    'form.emails': {
      deep: true,
      handler(val) {
        //console.log(val);
      }
    }
  },
  computed: {
    groupedArticles() {
      if (!Array.isArray(this.form?.articles)) {
        return [];
      }
      const groups = new Map();
      this.form.articles.forEach((article, index) => {
        const key = article.article_id ? String(article.article_id) : `single-${index}`;
        if (!groups.has(key)) {
          groups.set(key, {
            key,
            indexes: []
          });
        }
        groups.get(key).indexes.push(index);
      });
      return Array.from(groups.values()).map(group => ({
        ...group,
        articles: group.indexes.map(index => this.form.articles[index]),
        totalQuantity: group.indexes.reduce((sum, index) => sum + (Number(this.form.articles[index].quantity_required) || 0), 0),
        firstArticle: this.form.articles[group.indexes[0]]
      }));
    }
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
    this.$refs.modalEle.addEventListener('hide.bs.modal', async (event) => {
      if (this.isSaving) {
        this.isSaving = false;
        return;
      }
      if (this.isClosingConfirmed) {
        this.isClosingConfirmed = false;
        return;
      }

      if (this.selectedItems.length === 0) {
        return;
      }

      event.preventDefault();

      const res = await Toast.fire({
        toast: false,
        icon: 'question',
        title: 'Zamknąć okno?',
        html: 'Masz wybrane pozycje w zapytaniu ofertowym. Czy na pewno chcesz zamknąć okno i odznaczyć wybrane pozycje?',
        showDenyButton: true,
        position: 'center',
        timer: false,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie'
      });

      if (res.isConfirmed) {
        this.$emit('clear-selection');

        this.isClosingConfirmed = true;
        this.modalObj.hide();
      }
    });

    this.fetchQuoteRequestsNumbers();
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
  },

  methods: {
    updateGroupUnit(group) {
      const firstArticle = this.form.articles[group.indexes[0]];

      const unit = this.units.find(
        unit => Number(unit.id) === Number(firstArticle.unit_id)
      );

      group.indexes.forEach(idx => {
        this.form.articles[idx].unit_id = firstArticle.unit_id;
        this.form.articles[idx].unit_name = unit?.name || '';
      });
    },
    updateArticleUnit(idx) {
      const article = this.form.articles[idx];

      const unit = this.units.find(
        unit => Number(unit.id) === Number(article.unit_id)
      );

      article.unit_name = unit?.name || '';
    },
    toggleArticleGroup(groupKey) {
      this.expandedGroups = {
        ...this.expandedGroups,
        [groupKey]: !this.expandedGroups[groupKey]
      };
    },

    isArticleGroupExpanded(groupKey) {
      return !!this.expandedGroups[groupKey];
    },
    onDueDateChange(args) {
      if (!args.value) {
        this.form.dueDate = null;
        return;
      }

      const d = args.value;

      this.form.dueDate =
        `${String(d.getDate()).padStart(2, '0')}.` +
        `${String(d.getMonth() + 1).padStart(2, '0')}.` +
        `${d.getFullYear()}`;
    },

    setEmailCustomer(key, item) {
      this.form.emails[key].customer_id = item.customer_id;
    },

    async getSuppliersEmails() {
      const suppliers = await axios.get(route('suppliers.get-all-suppliers'));
      return suppliers.data;
    },

    changeComment(event) {
      this.form.comment = event;
    },

    defaultDueDate() {
      const today = new Date();
      const nextWeek = new Date(today);
      //nextWeek.setDate(today.getDate() + 7);
      nextWeek.setDate(today.getDate());
      const year = nextWeek.getFullYear();
      const month = String(nextWeek.getMonth() + 1).padStart(2, '0');
      const day = String(nextWeek.getDate()).padStart(2, '0');

      return `${day}.${month}.${year}`;
    },

    producerIdOf(item) {
      return item?.article?.producer?.id ?? item?.article?.producer_id ?? null;
    },

    mergeSelectedItems(items) {
      const map = new Map();

      for (const item of (items || [])) {
        const articleId = item.article_id ?? item.article?.id;
        if (!articleId) continue;

        const producerId = this.producerIdOf(item);
        const key = `${articleId}::${producerId ?? 'no-producer'}`;

        const qty =
          (Number(item.quantity_required) || 0) * (item.numbering?.quantity || 1);

        const in_target_warehouse = item?.article_project_warehouse?.quantity;

        const comment = item.comments ?? item.comment ?? null;

        if (!map.has(key)) {
          map.set(key, {
            article: item.article,
            article_id: articleId,
            producer_id: producerId,
            producer_name: item.article?.producer?.name || null,

            comments: comment ? [comment.trim()] : [],

            project_id: item.project_id,
            team_name: item.team_name,

            unit_id: item.article?.unit_id,
            unit_name: item.article?.article_unit?.name,

            sum_quantity_required: Number(qty.toFixed(2)),
            in_target_warehouse: in_target_warehouse,

            sources: [{
              article_id: articleId,
              required_project_item_id: item.id,
              comments: comment,
            }],
          });

        } else {
          const row = map.get(key);

          row.sum_quantity_required = Number(
            (row.sum_quantity_required + qty).toFixed(2)
          );

          if (comment && !row.comments.includes(comment.trim())) {
            row.comments.push(comment.trim());
          }

          row.sources.push({
            article_id: articleId,
            required_project_item_id: item.id,
            comments: comment,
          });
        }
      }

      return Array.from(map.values()).map(row => ({
        ...row,
        comments: row.comments.join(' | ')
      }));
    },

    async fetchQuoteRequestsNumbers(event) {
      let search = event?.target.value || null;
      try {
        const response = await axios.get(route('quoteRequests.numbers.get'), {
          params: {
            quoteRequestNumber: search,
          }
        });

        if (response.data && response.data.quoteRequestNumbers) {
          this.formatQuoteRequestsNumbers(response.data.quoteRequestNumbers);
        }
      } catch (errors) {
        this.$emit('error', errors);
      }

      return false;
    },

    formatQuoteRequestsNumbers(numbers) {
      this.quoteRequestNumbers = numbers.map(number => ({
        label: number.request_number,
        value: number.request_number
      }));
    },

    addEmailsRow() {
      const lastIndex = Object.keys(this.form.emails).length;
      this.$set(this.form.emails, lastIndex, {
        to: null,
        dw: ''
      });
    },

    removeEmailsRow(idx) {
      this.$delete(this.form.emails, idx);
      const updatedEmails = {};
      Object.keys(this.form.emails).forEach((key, newIdx) => {
        updatedEmails[newIdx] = this.form.emails[key];
      });

      this.form.emails = updatedEmails;
    },

    saveQuoteRequest() {
      const mailError = this.checkMails();
      if (mailError) {
        this.$emit('added-error', mailError);
        return;
      }

      this.form.post(route('quoteRequests.store'), {
        onSuccess: (resp) => {
          this.$emit('added-success', 'Zapytanie ofertowe zostało utworzone.');
          this.$emit('updated-article', true);
          this.$emit('clear-selection');
          this.isSaving = true;
          this.hide();
        },
        onError: (errors) => {
          console.log('errors:', errors);
          this.errors = errors;
          let errorMessages = Object.values(errors).flat().join(', ');
          this.$emit('added-error', 'Błąd podczas tworzenia zapytania: ' + errorMessages);
        }
      });
    },

    checkMails() {
      if (!this.form.with_send) {
        return false;
      }
      const emailArray = Object.values(this.form.emails);
      if (emailArray.length === 0) {
        return 'Trzeba dodać przynajmniej jeden email.';
      }
      const hasNullTo = emailArray.some(email => email.to === null);
      if (hasNullTo) {
        return 'Pole "mail dostawcy" jest puste.';
      }
      const hasEmptyTo = emailArray.some(email => !email.to || email.to.trim() === '');
      if (hasEmptyTo) {
        return 'Jeden z maili jest pusty (brak adresu).';
      }
      return false;
    },

    removeArticle(idx) {
      this.form.articles.splice(idx, 1);
    },

    hasError(field) {
      const error = this.errors && this.errors[field];
      return error;
    },

    getErrorMessage(field) {
      if (!this.errors[field]) {
        return '';
      }

      if (/^Pole .*? jest wymagane\.$/.test(this.errors[field])) {
        return 'To pole jest wymagane.';
      }

      return 'To pole ma niepoprawną wartość';
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },

    setWithSend(value) {
      this.form.with_send = value;
    },

    normalizeEmail(email) {
      if (!email) return null;
      return String(email).trim().toLowerCase();
    },

    prepareSuppliersEmails(items) {
      const seenKeys = new Set();
      const suppliersEmails = {};
      let index = 0;

      (items || []).forEach(item => {
        (item.suppliers || []).forEach(supplier => {
          const email = supplier?.customers_data?.email;
          const normalized = this.normalizeEmail(email);
          const supplierId =
            supplier?.customer_id ??
            supplier?.customer?.id ??
            supplier?.id ??
            null;

          const key = supplierId
            ? `supplier:${supplierId}`
            : (normalized ? `email:${normalized}` : null);

          if (!key) return;
          if (seenKeys.has(key)) return;

          seenKeys.add(key);
          suppliersEmails[index++] = {
            to: email || null,
            customer_id: supplierId,
            dw: null,
          };
        });
      });

      if (index === 0) {
        suppliersEmails[0] = { to: null, dw: null };
      }

      return suppliersEmails;
    },

    async getDefaultProducentForSelectedItem() {
      const articles = this.selectedItems.map(item => item.article);

      let producers = await axios.post(
        route('project.get-selected-producent-for-articles', { projectId: this.project }),
        {
          articles: articles
        }
      );

      this.producentSelectedInProject = [];

      if (producers.data[0].length > 0) {
        producers.data[0].forEach(innerArray => {
          innerArray.forEach(item => {
            if (item.article?.producer?.name && item.article_id) {
              if (!this.producentSelectedInProject[item.article_id]) {
                this.producentSelectedInProject[item.article_id] = [];
              }
              this.producentSelectedInProject[item.article_id].push(item.article.producer.name);
            }
          });
        });
      }
    },
    getProducerClass(articleId, producerName) {
      if (!this.producentSelectedInProject?.[articleId]) return 'text-danger';
      const producers = this.producentSelectedInProject[articleId];
      if (producers.length === 0) return 'text-danger';
      if (producers[0] && producerName === producers[0]) return 'text-success';
      if (producers[1] && producerName === producers[1]) return 'text-warning';
      if (producers[2] && producerName === producers[2]) return 'text-warning';
      return 'text-danger';
    },

    async loadReservations() {
      for (const article of this.form.articles) {
        try {
          const response = await axios.get(route('warehouse.check-article-reservation', {
            article: article.article_id,
            required_project_item_id: article.required_project_item_id,
            reserving: 0
          }));

          const key = `${article.article_id}-${article.required_project_item_id}`;
          this.reservations[key] = response.data;

        } catch (error) {
          console.error(error);
        }
      }
    }
  }
}
</script>


<style scoped>
.widthFirstTd {
  width: 150px;
}

.reservation-approved {
  color: #1abc9c !important;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
}

.reservation-notapproved {
  color: #e7515a !important;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
}

.btn.btn-sm.btn-outline-danger {
  padding: 2px 6px;
  font-size: 12px;
  line-height: 1;
}
</style>